'use client'

import { useEffect } from 'react'

import { toast } from 'sonner'

import { useAppRouter, useSearchParams } from '@/shared/lib/router'

export function QueryParamToast() {
  const searchParams = useSearchParams()
  const router = useAppRouter()

  useEffect(() => {
    if (searchParams.get('email_confirmed') === 'true') {
      toast.success('E-mail confirmado com sucesso!')
      const url = new URL(window.location.href)
      url.searchParams.delete('email_confirmed')
      router.replace(url.pathname + (url.search || ''))
    }

    if (searchParams.get('email_confirmation_error') === 'true') {
      toast.error('Não foi possível confirmar o e-mail. O link pode ter expirado.')
      const url = new URL(window.location.href)
      url.searchParams.delete('email_confirmation_error')
      router.replace(url.pathname + (url.search || ''))
    }
  }, [searchParams, router])

  return null
}
